<div class="flex flex-col justify-center items-center gap-4 h-screen">
    <div
        class="bg-white dark:bg-gray-800 shadow-lg p-8 border border-gray-200 dark:border-gray-700 rounded-md max-w-[1024px] text-center"
    >
        <i class="mb-6 !text-[70px] text-red-500 pi pi-times-circle"></i>

        <app-heading [content]="title()" text="left" />

        <p class="mt-2 mb-4">{{ message() }}</p>
    </div>

    <app-support />

    <div>
        <p-button (click)="logout()" severity="danger">
            <i class="material-icons" style="font-size: 18px">logout</i> Logout
        </p-button>
    </div>
</div>
